import { useState } from "react";
import { deepCopy, updateNestedValue } from "../../../../../../common/services/common.service";
import Popup from "../../../../../../common/components/popup";
import ReconciliationRequestItemBasicInfoComponent from "./reconciliation-request-item-basic-info.component";

export const ReconciliationRequestItemPopup = ({ 
  selectedReconciliationRequestItem,
  closeModal,
  handleSaveReconciliationRequestItem,
}: any) => {
  console.log('selectedReconciliationRequestItem', selectedReconciliationRequestItem)
    const [localAttribute, setLocalAttribute] = useState(deepCopy(selectedReconciliationRequestItem));

    const handleLocalFormChange = ({path, value}: any) => {
      console.log('selectedReconciliationRequestItem, path, value', selectedReconciliationRequestItem, path, value)
      const updatedData = updateNestedValue(selectedReconciliationRequestItem, path, value)
  
      console.log('updatedData', updatedData)
      setLocalAttribute({...updatedData});
    };

    const handleFormSubmit = () => {
      // setSelectedProductSpecificationAttributeItem(localAttribute);
      handleSaveReconciliationRequestItem(localAttribute)
    };

    return (
      <>
        <Popup onClose={closeModal}>
          <ReconciliationRequestItemBasicInfoComponent
            onClose={closeModal}
            handleInnerFormChange={handleLocalFormChange}
            selectedReconciliationRequestItem={selectedReconciliationRequestItem}
            handleFormSubmit={handleFormSubmit}
          />
        </Popup>
      </>
    )
  }